import {
    boBriefTemplateCreateUrl,
    boBriefTemplateEditUrl,
    boBriefTemplatesUrl,
    boCommentsSnapUrl,
    boOrderBriefDetailUrl,
    boOrderCreateUrl,
    boOrdersAgencyBonusesUrl,
    boOrdersBriefsUrl,
    boOrdersChartUrl,
    boOrdersDetailUrl,
    boOrdersEditUrl,
    boOrdersHistoryUrl,
    boOrdersInvoicingUrl,
    boOrdersProductionUrl,
    boOrdersReportAmbassadorUrl,
    boOrdersReportAskAnExpertUrl,
    boOrdersReportTestingUrl,
    boOrdersReportUrl,
    boOrdersSignedUrl,
    boOrdersUrl,
    boPaymentImportRf,
    boPaymentOrdersUrl,
    boTestingCreateUrl,
    boTestingEditUrl,
    briefClientUrl,
} from "@/mk2/apps/bo/urls";
import { DynamicRoute } from "@/mk2/containers/Application/Application";

export const routes: DynamicRoute[] = [
    {
        app: "bo",
        path: boBriefTemplatesUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/BriefTemplates/BriefTemplatesPage" /* webpackChunkName: "bo.BriefTemplates" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/BriefTemplates/BriefTemplatesPage"],
    },
    {
        app: "bo",
        path: boBriefTemplateCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/BriefTemplateEdit/BriefTemplateEditPage" /* webpackChunkName: "bo.BriefTemplateEdit" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/BriefTemplateEdit/BriefTemplateEditPage"],
    },
    {
        app: "bo",
        path: boBriefTemplateEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/BriefTemplateEdit/BriefTemplateEditPage" /* webpackChunkName: "bo.BriefTemplateEdit" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/BriefTemplateEdit/BriefTemplateEditPage"],
    },
    {
        // public, unauthenticated client-facing brief page (access_key gated)
        app: "bo",
        path: briefClientUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/BriefClient/BriefClientPage" /* webpackChunkName: "bo.BriefClient" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/BriefClient/BriefClientPage"],
    },
    {
        app: "bo",
        path: boOrdersReportTestingUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersReportTesting/OrdersReportTestingPage" /* webpackChunkName: "bo.OrdersReportTesting" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersReportTesting/OrdersReportTestingPage"],
    },
    {
        app: "bo",
        path: boOrdersReportAmbassadorUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersReportAmbassador/OrdersReportAmbassadorPage" /* webpackChunkName: "bo.OrdersReportAmbassador" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersReportAmbassador/OrdersReportAmbassadorPage"],
    },
    {
        app: "bo",
        path: boOrdersReportAskAnExpertUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersReportAskAnExpert/OrdersReportAskAnExpertPage" /* webpackChunkName: "bo.OrdersReportAskAnExpert" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersReportAskAnExpert/OrdersReportAskAnExpertPage"],
    },
    {
        app: "bo",
        path: boOrdersReportUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersReport/OrdersReportPage" /* webpackChunkName: "bo.OrdersReport" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersReport/OrdersReportPage"],
    },
    {
        app: "bo",
        path: boOrdersProductionUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderProduction/OrderProductionPage" /* webpackChunkName: "bo.OrderProduction" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderProduction/OrderProductionPage"],
    },
    {
        app: "bo",
        path: boPaymentImportRf,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/PaymentImportRf/PaymentImportRfPage" /* webpackChunkName: "bo.PaymentImportRf" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/PaymentImportRf/PaymentImportRfPage"],
    },
    {
        app: "bo",
        path: boPaymentOrdersUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/PaymentOrders/PaymentOrdersPage" /* webpackChunkName: "bo.PaymentOrders" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/PaymentOrders/PaymentOrdersPage"],
    },
    {
        app: "bo",
        path: boOrdersUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/Orders/OrdersPage" /* webpackChunkName: "bo.Orders" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/Orders/OrdersPage"],
    },
    {
        app: "bo",
        path: boCommentsSnapUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/CommentsSnap/CommentsSnapPage" /* webpackChunkName: "bo.CommentsSnap" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/CommentsSnap/CommentsSnapPage"],
    },
    {
        app: "bo",
        path: boOrdersChartUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersChart/OrdersChartPage" /* webpackChunkName: "bo.OrdersChart" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersChart/OrdersChartPage"],
    },
    {
        app: "bo",
        path: boOrdersInvoicingUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersInvoicing/OrdersInvoicingPage" /* webpackChunkName: "bo.OrdersInvoicing" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersInvoicing/OrdersInvoicingPage"],
    },
    {
        app: "bo",
        path: boOrdersSignedUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersSigned/OrdersSignedPage" /* webpackChunkName: "bo.OrdersSigned" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersSigned/OrdersSignedPage"],
    },
    {
        app: "bo",
        path: boOrdersAgencyBonusesUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrdersAgencyBonuses/OrdersAgencyBonusesPage" /* webpackChunkName: "bo.OrdersAgencyBonuses" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrdersAgencyBonuses/OrdersAgencyBonusesPage"],
    },
    {
        app: "bo",
        path: boOrderCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderCreate/OrderCreatePage" /* webpackChunkName: "bo.OrderCreate" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderCreate/OrderCreatePage"],
    },
    {
        app: "bo",
        path: boOrdersEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderEdit/OrderEditPage" /* webpackChunkName: "bo.OrderEdit" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderEdit/OrderEditPage"],
    },
    {
        app: "bo",
        path: boOrdersHistoryUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderHistory/OrderHistoryPage" /* webpackChunkName: "bo.OrderHistory" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderHistory/OrderHistoryPage"],
    },
    {
        app: "bo",
        path: boOrderBriefDetailUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderBriefDetail/OrderBriefDetailPage" /* webpackChunkName: "bo.OrderBriefDetail" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderBriefDetail/OrderBriefDetailPage"],
    },
    {
        app: "bo",
        path: boOrdersBriefsUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderBrief/OrderBriefPage" /* webpackChunkName: "bo.OrderBrief" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderBrief/OrderBriefPage"],
    },
    {
        app: "bo",
        path: boOrdersDetailUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/OrderDetail/OrderDetailPage" /* webpackChunkName: "bo.OrderDetail" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/OrderDetail/OrderDetailPage"],
    },
    {
        app: "bo",
        path: boTestingEditUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/TestingEditBo/TestingEditBoPage" /* webpackChunkName: "bo.TestingEditBo" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/TestingEditBo/TestingEditBoPage"],
    },
    {
        app: "bo",
        path: boTestingCreateUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/bo/containers/TestingCreateBo/TestingCreateBoPage" /* webpackChunkName: "bo.TestingCreateBo" */
            );
        },
        modules: ["@/mk2/apps/bo/containers/TestingCreateBo/TestingCreateBoPage"],
    },
];
